<template>
    <el-row :gutter="gutter">
        <el-col v-for="(item, index) in photos" :key="rowKey ? item[rowKey] : index"
            :span="setSpan ? setSpan(item, index) : span">
            <slot :row="item" :index="index" :disabled="setDisabled(item)" />
        </el-col>
    </el-row>
</template>
  
<script>
export default {
    name: 'BaseMTGrid',

    props: {
        photos: {
            type: Array,
            default: () => []
        },
        gutter: {
            type: Number,
            default: 20
        },
        span: {
            type: Number,
            default: 20
        },
        rowKey: String,
        srcKey: String,
        exclude: {
            type: Array,
            default: () => ['no_photo']
        },
        setSpan: Function,
        url: [String, Function]
    },
    data() {
        return {
            newPoto: []
        }
    },

    computed: {
    },

    watch: {
        photos(val) {
            this.newPoto= []
            this.$nextTick(() => {
                this.newPoto = val
            })
        }
    },
    methods: {
        setDisabled(row) {
            if (this.srcKey && row) {
                const src = row[this.srcKey]
                return !src || this.exclude.some(k => src.indexOf(k) > -1)
            }
            return false
        }
    }
}
</script>
  
<style lang="scss" scoped></style>
  